/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
function l(e) {
  const t = [
    /* @__PURE__ */ n.createElement(
      "input",
      {
        key: 0,
        checked: e.selectionValue,
        id: e.inputId,
        type: "checkbox",
        className: "k-checkbox k-checkbox-md k-rounded-md",
        onChange: (c) => e.selectionChange({
          field: e.field,
          syntheticEvent: c
        })
      }
    ),
    /* @__PURE__ */ n.createElement("label", { key: 1, className: "k-checkbox-label", htmlFor: e.inputId })
  ];
  return /* @__PURE__ */ n.createElement(n.Fragment, null, e.render ? e.render.call(void 0, t, e) : t);
}
export {
  l as HeaderSelectionCell
};
